"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UserManager = _interopRequireDefault(require("../../oidc/UserManager"));

const LoginPage = () => {
  const onLoginButtonClick = () => {
    _UserManager.default.signinRedirect();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: 20,
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Welcome to HealthMpowerment!!"), /*#__PURE__*/_react.default.createElement("p", null, "Please log in."), /*#__PURE__*/_react.default.createElement("button", {
    style: {
      width: 150
    },
    onClick: onLoginButtonClick
  }, "Login"));
};

var _default = LoginPage;
exports.default = _default;